if (!customElements.get('hoculus-collection-add-to-cart')) {
  class HoculusCollectionAddToCart extends HTMLElement {
    constructor() {
      super();
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('[data-product-tile-atc]');
      if (!this.form) return;
      this.form.addEventListener('submit', this.onSubmit);
    }

    async onSubmit(e) {
      e.preventDefault();

      const btn = this.form.querySelector('[data-btn-add-to-cart]');
      const variantId = this.form.querySelector('input[name="id"]')?.value;

      if (!variantId) return;

      try {

        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(variantId, 10),
                  quantity: 1
                }
              ]
            })
          }
        );

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        await response.json();

        if (window.hoculusItemAddedCallback) {
          window.hoculusItemAddedCallback();
        }
      } catch (error) {
        console.error('ATC error:', error);
      }
    }
  }

  customElements.define('hoculus-collection-add-to-cart', HoculusCollectionAddToCart);
}